import React, { Component } from 'react';
import Post from '../components/Post';
import { database } from '../firebase';
import Fuse from 'fuse.js';

class Posts_s extends Component {
  constructor(props) {
    super(props);
    this.database = database.ref().child('posts');
    this.state = {
      posts: [],
      isLoading: true, // manage loading state
      errorMessage: '', // store error message
    };
  }

  componentWillMount() {
    const previousPosts = this.state.posts;

    this.database.on('child_added', (snap) => {
      previousPosts.push({
        id: snap.key,
        postTitle: snap.val().postTitle,
        postContent: snap.val().postContent,
        postDate: snap.val().postDate,
        postImage: snap.val().postImage,
        postAuthor: snap.val().postAuthor,
      });

      const options = {
        includeScore: true,
        keys: ['postTitle', 'postContent'],
      };

      if (window.location.search.length > 2) {
        const fuse = new Fuse(previousPosts, options);

        const query = decodeURIComponent(window.location.search.slice(3)).toLowerCase();
        const result = fuse.search(query);

        if (result.length < 1 && window.location.search.length > 2) {
          this.setState({
            isLoading: false,
            errorMessage: 'Sonuç Bulunamadı :(',
          });
        } else {
          this.setState({
            posts: result,
            isLoading: false,
            errorMessage: '', // Clear any previous errors
          });
        }
      } else {
        // Shuffle posts
        for (let i = previousPosts.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [previousPosts[i], previousPosts[j]] = [previousPosts[j], previousPosts[i]];
        }

        this.setState({
          posts: previousPosts,
          isLoading: false,
          errorMessage: '', // Clear any previous errors
        });
      }
    });
  }

  render() {
    const fuseOrNot = window.location.search.length > 2;

    return (
      <>
        <div>
          {this.state.isLoading ? (
            <img src="/loading.svg" id="loading-non" className="loading-non" />
          ) : this.state.errorMessage ? (
            <p id="error_p" className="error_p">
              {this.state.errorMessage}
            </p>
          ) : (
            this.state.posts.length > 0 &&
            this.state.posts.map((post) => (
              <Post
                postContent={fuseOrNot ? post.item.postContent : post.postContent}
                postTitle={fuseOrNot ? post.item.postTitle : post.postTitle}
                postDate={fuseOrNot ? post.item.postDate : post.postDate}
                postImage={fuseOrNot ? post.item.postImage : post.postImage}
                postAuthor={fuseOrNot ? post.item.postAuthor : post.postAuthor}
                postId={fuseOrNot ? post.item.id : post.id}
                key={fuseOrNot ? post.item.id : post.id}
              />
            ))
          )}
        </div>
      </>
    );
  }
}

export default Posts_s;